import _get from "lodash/get";
// Bills reducer
export var getBillers = function getBillers(identity) {
  return _get(identity, 'bills.billers');
};
export var getSavingsEstimate = function getSavingsEstimate(identity) {
  return _get(identity, 'bills.savingsEstimate');
};
export var getAnnualSavings = function getAnnualSavings(identity) {
  return _get(identity, 'bills.savingsEstimate.annual_savings');
};
export var getOneTimeFee = function getOneTimeFee(identity) {
  return _get(identity, 'bills.savingsEstimate.one_time_fee');
};
export var getAnnualSavingsAfterFee = function getAnnualSavingsAfterFee(identity) {
  return _get(identity, 'bills.savingsEstimate.annual_savings_after_fee');
}; // Completed steps

export var isExpectedSavingsStepComplete = function isExpectedSavingsStepComplete(identity) {
  return _get(identity, 'temp.bills.isExpectedSavingsStepComplete');
};
export var isHowItWorksStepComplete = function isHowItWorksStepComplete(identity) {
  return _get(identity, 'temp.bills.isHowItWorksStepComplete');
};
export var getCreateAccountSuccess = function getCreateAccountSuccess(identity) {
  return _get(identity, 'bills.createAccountSuccess');
}; // Pending requests

export var isSavingsEstimateRequestPending = function isSavingsEstimateRequestPending(identity) {
  return _get(identity, 'requests.getSavingsEstimate.hasPendingRequests');
};
export var isCreateBillsharkAccountPending = function isCreateBillsharkAccountPending(identity) {
  return _get(identity, 'requests.createBillsharkAccount.hasPendingRequests');
}; // Temp data

export var getBillData = function getBillData(identity) {
  return _get(identity, 'temp.bills');
};
export var getBiller = function getBiller(identity) {
  return _get(identity, 'temp.bills.biller');
};
export var getBillerName = function getBillerName(identity) {
  return _get(identity, 'temp.bills.billerName');
};
export var getBillAmount = function getBillAmount(identity) {
  return _get(identity, 'temp.bills.billAmount');
};